<template>
  <div :class="isNotApp ? 'box' : 'box1'">
    <!-- 头部 -->
    <headerNav v-show="isNotApp && downloadShow" :header-title="webName" :showback="true" :show-sort="'0'" :isBBSHeader="'1'" :showBbsCat="showBbsCat" @beforeChange="beforeChangeCat" @changeFid="changeFid" />
    <!-- tab切换 -->
    <van-tabs v-if="showBbsCat==='0'" v-model="active" @click="findFun">
      <van-tab v-for="(v,i) in info" :key="i" :title="v.title" :name="v.id">
        <div v-show="active==1" :class="isNotApp?'qqqq':''">
          <!-- 资料小组列表 -->
          <van-list v-show="isShow" v-model="loading" :finished="finished" :immediate-check="false" :offset="10" :finished-text="groupList.length > 0 ? '没有更多了' : ''" @load="onLoad">
            <van-cell v-for="(item,index) in groupList" :key="index">
              <div class="group_item_box" @click.stop="toPost(item.gid)">
                <div class="group_item_left">
                  <img class="item_logo" :src="item.thumb" alt="">
                </div>
                <div class="group_item_right">
                  <div class="item_right_top">
                    <p class="item_top_title">{{ item.group_name }}</p>
                    <span v-if="item.is_follow == 1" class="span_btn_gray" @click.stop="Nofollow(item.gid)">已关注</span>
                    <span v-if="item.is_follow == 0" class="span_btn_red" @click.stop="follow(item.gid)">+ 关注</span>
                  </div>
                  <div class="item_right_mid">
                    <p class="item_introduce">{{ item.introduce }}</p>
                  </div>
                  <div class="item_right_bot">
                    <img class="follow_icon" src="../../assets/team.png" alt>
                    <span class="follow_num">{{ item.follow_num }} 关注</span>
                  </div>
                </div>
              </div>
            </van-cell>
          </van-list>
          <div v-if="!loading && groupList.length == 0" class="nodatas">
            <img src="@/assets/new_kong.png" alt="kong">
            <p>当前分类下暂无资料小组~</p>
          </div>
        </div>
        <!-- 最新精华贴子列表 -->
        <div v-show="active==2" :class="isNotApp?'wwww':''">
          <van-list v-show="isOpen" v-model="loading" :finished="finished" :immediate-check="false" :offset="10" :finished-text="essenceList.length > 0 ? '没有更多了' : ''" @load="onLoads">
            <van-cell v-for="(val,dex) in essenceList" :key="dex">
              <div class="optionTwo_box" @click.stop="toDetail(val.tid)">
                <div class="optionTwo">
                  <div class="top">
                    <div class="top_left">
                      <h1>{{ val.title }}</h1>
                    </div>
                    <div class="top_right">
                      <img :src="val.pic" alt>
                    </div>
                  </div>
                  <div class="bottom">
                    <div class="bottom_left">
                      <div class="bottom_left_left">
                        <img src="@/assets/yjs.png" alt>
                        <span>{{ val.view_num }}</span>人浏览
                      </div>
                      <div class="bottom_left_right">
                        <img src="@/assets/xsx.png" alt>
                        <span>{{ val.reply_num }}</span>人跟帖
                      </div>
                    </div>
                    <div class="bottom_right">{{ val.create_time }}</div>
                  </div>
                </div>
              </div>
            </van-cell>
          </van-list>
          <div v-if="!loading && essenceList.length == 0" class="nodatas">
            <img src="@/assets/new_kong.png" alt="kong">
            <p>当前分类下暂无最新精华帖~</p>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import tool from '@/utils/tools.js'
import { findDate, getFidEssenceT } from '@/api/infohome'// 资料小组和最新精华接口引入
import { attendGroup, removeGroup } from '@/api/bbsfind'// 关注和取消关注接口引入
import { getRowSeo } from '@/api/bbshome'
import WechatState from '@/utils/isWechatState.js'

export default {
  components: {
  },
  data() {
    return {
      loading: false,
      finished: false,
      webName: Cookies.get('fname') || '分类',
      fid: Cookies.get('fid') || '', // 分类id
      showBbsCat: Cookies.get('fid') ? '0' : '1',
      active: 0, // 默认选中
      pages: 1,// 默认页数
      count: '', // 小组数据总数量
      counts: '', // 精华数据总数量
      info: [{ title: '资料小组', id: 1 }, { title: '最新精华', id: 2 }],
      groupList: [], // 小组列表数据
      essenceList: [], // 精华列表数据
      isOpen: false, // 精华
      isShow: true, // 小组
      agency_id: '',
      isNotApp: true, // 区分APP
      downloadShow: true,
      Before_scollH: 0
    }
  },
  created() {
    this.agency_id = Cookies.get('agency_id')
    if (!Cookies.get('fid')) {
      this.showBbsCat = '1'
    }
    else{
      this.showBbsCat = '0'
      // 创建组件时，加载第1页数据
      this.getList()
      this.getFidEssenceTFun()
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (document.getElementsByClassName('qqqq')[0]) {
        document.getElementsByClassName('qqqq')[0].addEventListener('scroll', this.scroll, true)
        console.log(document.getElementsByClassName('qqqq')[0])
      }
    })

    this.getSeo()
    if (tool.isInApp()) {
      this.isNotApp = false
    }
    // 挂载函数，方便APP调用
    if (tool.isInApp()) {
      window.appCacheFid = this.appCacheFid
    }
  },
  methods: {
    // 弹出专业，选择
    beforeChangeCat(){
      this.showBbsCat = '1'
    },
    // 选择分类
    changeFid(value) {
      console.log(value);
      this.webName = value.fname
      this.fid = value.fid
      this.showBbsCat = '0'
      // this.groupList = []
      // this.essenceList = []
      this.beforeGetLists()
    },
    // 获取数据入口
    beforeGetLists(){
      this.pages = 1
      this.finished = false
      this.count = 0
      this.getList()
      this.getFidEssenceTFun()
    },
    getSeo() {
      var params = {
        type: 4
      }
      getRowSeo(params).then(res => {
        console.log(res.result, 'res.resultres.result')
        // 设置title标题
        const my_title = document.getElementsByTagName('title')[0]
        my_title.innerHTML = res.result.result.title
        // 设置关键词
        const my_keys = document.getElementsByName('keywords')[0]
        my_keys.content = res.result.result.words
        // 设置描述1
        const my_description = document.getElementsByName('description')[0]
        my_description.content = res.result.result.description
      })
    },
    // APP调用 存储id
    appCacheFid(fid, name) {
      const ffid = Number(fid)
      if (ffid > 0) {
        Cookies.set('fid', ffid)
        this.fid = fid
        this.beforeGetLists()
      }
      if (name && name.length > 0) {
        Cookies.set('Fname', name)
      }
    },
    // 资料小组
    getList() {
      this.loading = true
      const date = {
        agency_id: this.agency_id,
        fid: this.fid,
        page: this.pages
      }
      findDate(date).then(res => {
        console.log(res)
        if (res.errNo === 0) {
          const result = res.result || {}
          // 请求返回当页的列表
          var itemList = result.list || []
          this.loading = false
          this.count = result.count
          // 将新数据与老数据进行合并
          if (this.pages != 1) {
            this.groupList = this.groupList.concat(itemList)
          } else {
            this.groupList = itemList
          }
          // if (itemList && itemList.length === 0) {
          //   // 加载结束
          //   this.finished = true
          //   return
          // }
        }
        // 如果列表数据条数>=总条数，不再触发滚动加载
        if (this.groupList.length >= this.count) {
          this.finished = true
        }
        else{
          this.finished = false
        }
      }).catch(err => {
        this.loading = false
      })
    },
    // 最新精华
    getFidEssenceTFun() {
      this.loading = true
      const date = {
        fid: this.fid,
        page: this.pages
      }
      getFidEssenceT(date).then(res => {
        if (res.errNo === 0) {
          this.loading = false
          const result = res.result ? res.result : {}
          var itemLists = result.list ? result.list : []
          this.counts = result.count ? result.count : 0
          // 将新数据与老数据进行合并
          if (this.pages != 1) {
            this.essenceList = this.essenceList.concat(itemLists)
          } else {
            this.essenceList = itemLists
          }
          // if (itemLists == null || itemLists.length === 0) {
          //   // 加载结束
          //   this.finished = true
          //   return
          // }
        }
        // 如果列表数据条数>=总条数，不再触发滚动加载
        if (this.essenceList.length >= this.counts) {
          this.finished = true
        }
        else{
          this.finished = false
        }
      }).catch(err => {
        this.loading = false
      })
    },
    // tab切换
    findFun(name) {
      // console.log(name)
      this.pages = 1
      this.finished = false
      this.count = 0
      if (name === 1) {
        // 资料小组
        this.getList()
        this.isShow = true
        this.isOpen = false
      } else if (name === 2) {
        // 最新精华
        this.getFidEssenceTFun()
        this.isShow = false
        this.isOpen = true
        this.active = 2
        setTimeout(() => {
          if (document.getElementsByClassName('wwww')[1]) {
            // console.log(document.getElementsByClassName('wwww'), 'sssssssssssssss')
            document.getElementsByClassName('wwww')[1].addEventListener('scroll', this.scrolltwo, true)
          }
        }, 200)
        setTimeout(() => {
          if (document.getElementsByClassName('wwww')[1]) {
            this.scrolltwo()
          }
        }, 500)
      }
    },

    scroll() {
      // const _this = this
      // const scrollTop = document.getElementsByClassName('qqqq')[0].scrollTop
      // const tabsStyle = document.getElementsByClassName('van-tabs__wrap')[0]
      // if (scrollTop <= 0) { // 处理回弹
      //   _this.downloadShow = true
      // } else {
      //   const differH = scrollTop - _this.Before_scollH
      //   if (differH == 0) {
      //     _this.downloadShow = true
      //   }
      //   const scollType = differH > 0 ? 'down' : 'up'
      //   _this.Before_scollH = scrollTop
      //   if (scollType == 'down') {
      //     _this.downloadShow = false
      //     tabsStyle.style = 'margin-top: 0px'
      //   } else if (scollType == 'up') {
      //     _this.downloadShow = true
      //     if (!tool.isInApp()) {
      //       tabsStyle.style = 'margin-top: 40px;'
      //     }
      //   }
      // }
    },
    scrolltwo() {
      // const _this = this
      // const scrollTop = document.getElementsByClassName('wwww')[1].scrollTop
      // const tabsStyle = document.getElementsByClassName('van-tabs__wrap')[0]
      // console.log(scrollTop, 'scrollTop++++++++++')
      // if (scrollTop <= 0) { // 处理回弹
      //   _this.downloadShow = true
      // } else {
      //   const differH = scrollTop - _this.Before_scollH
      //   if (differH == 0) {
      //     _this.downloadShow = true
      //   }
      //   const scollType = differH > 0 ? 'down' : 'up'
      //   _this.Before_scollH = scrollTop
      //   if (scollType == 'down') {
      //     _this.downloadShow = false
      //     tabsStyle.style = 'margin-top: 0px'
      //   } else if (scollType == 'up') {
      //     _this.downloadShow = true
      //     if (!tool.isInApp()) {
      //       tabsStyle.style = 'margin-top: 40px;'
      //     }
      //   }
      // }
    },
    // 关注
    follow(gid) {
      const mplogin = WechatState.checkWechatMPLogin()
      if (!mplogin) return

      // console.log(gid, 'guanzhu')
      const date = {
        agency_id: this.agency_id,
        group_id: gid
      }
      attendGroup(date).then(res => {
        // console.log(res)
        const date = {
          agency_id: this.agency_id,
          fid: this.fid,
          page: this.page
        }
        findDate(date).then(res => {
          // console.log(res.result.list)
          this.groupList = res.result.list
        })
      })
    },
    // 取消关注
    Nofollow(gid) {
      const mplogin = WechatState.checkWechatMPLogin()
      if (!mplogin) return

      // console.log('quxiao', gid)
      const date = {
        agency_id: this.agency_id,
        group_id: gid
      }
      removeGroup(date).then(res => {
        // console.log(res)
        const date = {
          agency_id: this.agency_id,
          fid: this.fid,
          page: this.page
        }
        findDate(date).then(res => {
          // console.log(res.result.list)
          this.groupList = res.result.list
        })
      })
    },
    // 跳转讨论小组
    toPost(gid) {
      // 下面两行代码虽然注释，但是勿删
      // const mplogin = WechatState.checkWechatMPLogin()
      // if (!mplogin) return
      this.$router.push({
        path: 'datalist',
        query: {
          gid
        }
      })
    },
    // 跳转贴子详情
    toDetail(tid) {
      // 下面两行代码虽然注释，但是勿删
      // const mplogin = WechatState.checkWechatMPLogin()
      // if (!mplogin) return
      this.$router.push({
        name: 'D',
        params: {
          tid: tid + '.html'
        }
      })
    },
    // 资料小组下拉加载
    onLoad() {
      this.pages++
      // this.getList()
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.getList()
          this.timer = null
        }, 1000)
      }
    },
    // 最新精华下拉加载
    onLoads() {
      this.pages++
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.getFidEssenceTFun()
          this.timer = null
        }, 1000)
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    // console.log(to)
    // console.log(from)
    // 默认fid
    next()
  }
}
</script>

<style lang="less" scoped>
/deep/.van-tabs {
  overflow-y: hidden;
}
// /deep/.van-tabs__content{
//   background: #f5f5f5;
//   max-height: 100vh;
//   height: 80vh;
//   overflow:auto;
// }
/deep/.van-tab__pane {
  background: #f5f5f5;
}
/deep/.van-tab__text--ellipsis {
  font-size: 27px;
  overflow: visible;
}
/deep/.van-tab--active {
  color: red !important;
}
/deep/.van-tab {
  color: #000000;
  font-size: 27px;
}
/deep/.van-tabs__nav--line {
  width: 100%;
  position: relative;
  height: 88px;
}
/deep/.van-tabs__line {
  width: 128px;
  height: 6px;
  border-radius: 0;
}
/deep/.van-cell {
  border-radius: 12px;
  width: calc(100% - 50px) !important;
  margin: 20px 25px 0 25px !important;
  // padding: 0px 16px;
}
.tab {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 174px;
  background: white;
  border-radius: 15px;
  .tab_left {
    width: 80%;
    .group_att {
      margin-top: 20px;
      display: flex;
      align-items: center;
    }
    .tab_left_box {
      width: 480px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 12px;
      -webkit-transform-origin-x: 0;
      -webkit-transform: scale(0.85);
    }
    div:first-child > div {
      width: 122px;
      height: 122px;
      border-radius: 10px;
      margin-right: 40px;
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }
    div:first-child img {
      width: 122px;
      height: 122px;
      border-radius: 10px;
    }
    div:nth-child(2) > div:nth-child(2) {
      font-size: 20px;
      color: #919191;
      margin: 5px 0 20px 0;
      // margin-bottom: 20px;
      display: flex;
      align-items: center;
      height: 40px;
    }
    div:nth-child(2) > div:nth-child(2) > img {
      width: 30px;
      height: 25px;
      margin-right: 6px;
    }
    display: flex;
    h1 {
      font-size: 30px;
      color: #111111;
    }
    span {
      font-size: 26px;
      color: #919191;
      margin-right: 2px;
      vertical-align: sub;
      margin: 0 5px 0 5px;
      height: 40px;
      line-height: 45px;
    }
    div:nth-child(2) > div:nth-child(3) {
      font-size: 28px;
      color: #333333;
    }
  }
  .tab_right {
    width: 88px;
    height: 40px;
    line-height: 46px;
    text-align: center;
    border: 1px solid #a8a8a8;
    border-radius: 10px;
    font-size: 22px;
    color: #a8a8a8;
  }
  .tab_right_yes {
    width: 88px;
    height: 40px;
    line-height: 46px;
    text-align: center;
    border: 1px solid red;
    border-radius: 10px;
    font-size: 22px;
    color: red;
    span {
      margin-right: 9px;
    }
  }
  .tab_right_span {
    width: 92px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    border: 1px solid #e90000;
    border-radius: 10px;
    font-size: 22px;
    color: #e90000;
    span {
      margin-right: 9px;
    }
  }
}
.optionTwo_box {
  // background-color: sandybrown;
  padding: 10px 0;
  .optionTwo {
    position: relative;
    width: 100%;
    .top {
      height: 158px;
      margin-bottom: 25px;
      display: flex;
      justify-content: space-between;
      width: 100%;
      .top_left {
        width: calc(100% - 300px);
        h1 {
          font-size: 30px;
          color: #000000;
          line-height: 42px;
          overflow: hidden; /*必须结合的属性,当内容溢出元素框时发生的事情*/
          text-overflow: ellipsis; /*可以用来多行文本的情况下，用省略号“…”隐藏超出范围的文本 。*/
          display: -webkit-box; /*必须结合的属性 ，将对象作为弹性伸缩盒子模型显示 。*/
          -webkit-line-clamp: 2; /*用来限制在一个块元素显示的文本的行数。*/
          -webkit-box-orient: vertical; /*必须结合的属性 ，设置或检索伸缩盒对象的子元素的排列方式 。*/
        }
      }
      .top_right {
        img {
          width: 280px;
          height: 158px;
          border-radius: 15px;
        }
      }
    }
    .bottom {
      position: relative;
      display: flex;
      justify-content: space-between;
      .bottom_left {
        display: flex;
        div {
          font-size: 22px;
          color: #999999;
          letter-spacing: 2px;
          display: flex;
          align-items: center;
          img {
            // position: relative;
            // top: 50%;
            // transform: translateY(-50%);
            width: 28px;
            height: 28px;
            margin-right: 7px;
          }
        }
        div:nth-child(1) {
          margin-right: 54px;
        }
      }
      .bottom_right {
        font-size: 22px;
        color: #939393;
      }
    }
  }
}
.box {
  overflow-y: hidden;
  max-height: 100vh;
  /deep/.van-tabs__content {
    background: #f5f5f5;
    height: 100vh;
    overflow: auto;
  }
  /deep/.van-tabs--line .van-tabs__wrap {
    // background-color: #ffffff;
    padding: 0 25%;
    // height: 90px;
    width: 50%;
    margin: 0 auto;
    overflow-y: hidden;
    overflow-x: auto;
    margin-top: 80px;
  }
}
.box1 {
  overflow-y: hidden;
  max-height: 100vh;
  /deep/.van-tabs__content {
    background: #f5f5f5;
    height: 100vh;
    overflow: auto;
  }
  /deep/.van-tabs--line .van-tabs__wrap {
    // background-color: #ffffff;
    padding: 0 25%;
    // height: 90px;
    width: 50%;
    margin: 0 auto;
    overflow-y: hidden;
    overflow-x: auto;
    margin-top: 80px;
  }
}
.qqqq {
  width: 100%;
  height: calc(100vh - 200px);
  overflow: scroll;
}
.wwww {
  width: 100%;
  height: calc(100vh - 200px);
  overflow: scroll;
}
.nodatas {
  margin-top: 250px;
  text-align: center;
  p {
    color: #333;
    font-size: 26px;
    margin-top: 20px;
  }
}
.group_item_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 24px 0;
  .group_item_left {
    width: 122px;
    height: 122px;
    margin-right: 20px;
    .item_logo {
      width: 122px;
      height: 122px;
      border-radius: 10px;
    }
  }
  .group_item_right {
    display: flex;
    width: calc(100% - 142px);
    flex-direction: column;
    .item_right_top {
      // margin-top: -15px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .item_top_title {
        width: calc(100% - 100px);
        font-size: 30px;
        color: #333;
        font-weight: 500;
        word-break: break-all;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .span_btn_gray {
        display: inline-block;
        width: 88px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border: 2px solid #a8a8a8;
        border-radius: 10px;
        font-size: 22px;
        color: #a8a8a8;
        box-sizing: border-box;
      }
      .span_btn_red {
        display: inline-block;
        width: 88px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border: 2px solid #ee2e2e;
        border-radius: 10px;
        font-size: 22px;
        color: #ee2e2e;
        box-sizing: border-box;
      }
    }
    .item_right_mid {
      line-height: 30px;
      height: 30px;
      margin: 10px 0 10px 0;
      font-size: 24px;
      color: #333;
      word-break: break-all;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .item_right_bot {
      display: flex;
      align-items: center;
      line-height: 30px;
      .follow_icon {
        width: 30px;
        height: 25px;
        display: block;
        margin-right: 6px;
      }
      .follow_num{
        margin-top: 4px;
        font-size: 24px;
        color: #999;
      }
    }
  }
}
</style>
<style>
/* 隐藏滚动条的滑柄 */
::-webkit-scrollbar-thumb {
  display: none !important; /* 对于Webkit浏览器 */
}
/* 对于Firefox */
* {
  scrollbar-width: none !important; /* 对于Firefox, IE和Edge */
}
</style>

